import { render } from "./RecallQueuePage.vue?vue&type=template&id=6477ae62"
import script from "./RecallQueuePage.vue?vue&type=script&lang=js"
export * from "./RecallQueuePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__